<template lang="pug">
  .breadcrumbs
    .breadcrumbs__container
      .breadcrumbs__item(
        v-for="(item, i) in items"
        :class="{'breadcrumbs__item_last': i === items.length - 1}"
      )
        router-link.breadcrumbs__link(
          :to="item.link"
        )
          .text-with-icon(v-if="i === items.length - 1")
            icon(icon-name="left" class-name="breadcrumbs__back icon d-md-none" w="16" h="16")
            span(v-html="item.name")
          span(v-else v-html="item.name")
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: Array
  }
}
</script>

<style lang="scss">
  .breadcrumbs {
    @include text-sm;

    &__container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__item {

      &::after {
        content: "/";
        margin: 0 0.6em;
      }

      &:last-child::after {
        content: none;
      }

      @media (max-width: breakpoint(md, max)) {
        display: none;

        &_last {
          display: block;
        }
      }
    }

    &__link {
      color: inherit;
      font-weight: $font-weight-semibold;
      text-decoration: none;
    }

    &__link {
      transition: $transition-default color;

      &:hover {
        color: $color-primary;
      }
    }
  }
</style>
